// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3PPTC","header":"PatientBlock_header__io_x_","label":"PatientBlock_label__2wZ2c","option":"PatientBlock_option__EHLpL"};